import { render, staticRenderFns } from "./TransferMedicalSelector.vue?vue&type=template&id=d24d64ac&scoped=true&"
import script from "./TransferMedicalSelector.vue?vue&type=script&lang=ts&"
export * from "./TransferMedicalSelector.vue?vue&type=script&lang=ts&"
import style0 from "./TransferMedicalSelector.vue?vue&type=style&index=0&id=d24d64ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d24d64ac",
  null
  
)

export default component.exports